<template>
    <div class="flex grow h-0 py-2">
        <div class="flex flex-col h-full w-full px-2">
            <card-form
                :meta="cardMeta"
                components-path="views/counteragents/counteragent-card/field-wrappers"
                :use-default-buttons="true"
                :default-handlers="{ refresh: null, commit: null }"
                :callbacks="{ refreshData: refreshData, saveData: saveData, isDirty: null }"
                :to-remove-toolbar-items-names="['copy', 'edit', 'delete', 'settings']"
            />
        </div>
        <widgets-side-menu local-storage-key="counteragentElectroWidgetList" />
        <widgets-popup />
    </div>
</template>

<script setup>
import { useStore } from 'vuex';

import CardForm from '@/components/card-component/card-form.vue';
import WidgetsSideMenu from '@/components/card-component/widgets-side-menu.vue';
import WidgetsPopup from '@/components/card-component/widgets-popup.vue';

import cardMeta from '@/views/counteragents/counteragent-card/card-meta-readonly';
import useCounteragentWidgetList from '@/views/counteragents/counteragent-card/widget-list';
import { getCustomerCard, saveCustomerCard } from '@/service/counteragent-service';
import {useRoute} from "vue-router";

const route = useRoute();
const refreshData = async () => {
    return await getCustomerCard(route.params.id);
};

const saveData = async data => {
    // await saveById(save_args)
    return await saveCustomerCard(data);
};

const store = useStore();

const widgetList = useCounteragentWidgetList();
store.dispatch('createWidgetMetaList', widgetList);
</script>
